// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xZuoskPAQrNJ81 {
  margin-top: var(--ds-space-100, 8px);
  border-top: 1px solid var(--ds-border, #091e4224);
}
.xZuoskPAQrNJ81 fieldset {
  display: flex;
  flex-direction: column;
  margin-top: var(--ds-space-100, 8px);
  border: none;
}
.xZuoskPAQrNJ81 .AJo306I7aiUKbu {
  display: flex;
}
.xZuoskPAQrNJ81 .AJo306I7aiUKbu .NQllANamWE_HCR {
  display: flex;
  align-items: center;
  margin-bottom: var(--ds-space-150, 12px);
  gap: var(--ds-space-100, 8px);
}
.xZuoskPAQrNJ81 .AJo306I7aiUKbu .gOPL0_1YSe_lcY {
  display: flex;
  align-items: center;
  padding: var(--ds-space-050, 4px);
  background-color: var(--ds-background-neutral, #091e420f);
  color: var(--ds-text, #172b4d);
}
.xZuoskPAQrNJ81 .AJo306I7aiUKbu .gOPL0_1YSe_lcY input[type='checkbox'] {
  appearance: none;
}
.xZuoskPAQrNJ81 .AJo306I7aiUKbu .gOPL0_1YSe_lcY span {
  margin-right: var(--ds-space-050, 4px);
}
.xZuoskPAQrNJ81 .AJo306I7aiUKbu .gOPL0_1YSe_lcY:hover,
.xZuoskPAQrNJ81 .AJo306I7aiUKbu .gOPL0_1YSe_lcY:focus {
  cursor: pointer;
}
.xZuoskPAQrNJ81 .JUc7PqhDDiZwn3 {
  max-width: max-content;
  margin-top: var(--ds-space-100, 8px);
}
.xZuoskPAQrNJ81.iKeu_MCfyuKQLo fieldset {
  padding: unset;
}
.xZuoskPAQrNJ81.iKeu_MCfyuKQLo .AJo306I7aiUKbu {
  flex-direction: column;
}
.xZuoskPAQrNJ81.iKeu_MCfyuKQLo .AJo306I7aiUKbu .NQllANamWE_HCR {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.xZuoskPAQrNJ81.iKeu_MCfyuKQLo .JUc7PqhDDiZwn3 {
  align-self: flex-start;
  margin-top: var(--ds-space-0, 0px);
}
`, ""]);
// Exports
export var feedbackDetailContainer = `xZuoskPAQrNJ81`;
export var contentContainer = `AJo306I7aiUKbu`;
export var reasonsContainer = `NQllANamWE_HCR`;
export var reason = `gOPL0_1YSe_lcY`;
export var submitButton = `JUc7PqhDDiZwn3`;
export var flagTreatment = `iKeu_MCfyuKQLo`;
export default ___CSS_LOADER_EXPORT___;
